import React from "react";
import { Navigate } from "react-router-dom";

const AuthRedirect = () => {
  const user = localStorage.getItem("user");

  return user ? <Navigate to="/home" replace /> : <Navigate to="/landing" replace />;
};

export default AuthRedirect;
